import { render } from "./Home.vue?vue&type=template&id=5cc39a74"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=5cc39a74&lang=css"

import exportComponent from "D:\\DEV\\STATIC\\player-speakup\\player\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__